import { StockTypeStatus, TransactionType, TransferStatusEnum } from "@gtpl/shared-models/common-models";
import { ForkLiftJobStatus } from "@gtpl/shared-models/warehouse-management";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('stock_out')
export class StockOut {

    @PrimaryGeneratedColumn("increment",{name:'fork_lift_item_id'})
    forkLiftItemId:number;
    @Column("int",{
        nullable:true,
        name:"fork_lift_job_id"
        })
        forkLiftJobId:number;
    @Column("int",{
        nullable:true,
        name:"sale_order_id"
        })
        saleOrderId:number;
    @Column("int",{
        nullable:true,
        name:"sale_order_item_id"
        })
    saleOrderItemId:number;
    @Column("varchar",{
        nullable:false,
        length:50,
        name:"job_code"
        })
        jobCode:string;
    @Column({
        type: 'enum',
        enum: ForkLiftJobStatus,
        nullable: false,
        name: 'status',
        default:"Open",
    })
    status: ForkLiftJobStatus;
    @Column({
        type: 'enum',
        enum: TransactionType,
        nullable: false,
        name: 'job_purpose',
        default:"palleting",
    })
    transactionType: TransactionType;
    @Column("int", {
        nullable: true,
        name: "reported_id",
    })
    reportedId: number;
    @Column("int", {
        nullable: false,
        name: "shortage_cartons",
        default:0,
    })
    shortageCartons: number;
    @Column("int", {
        nullable: false,
        default:0,
        name: "damaged_cartons",
    })
    damagedCartons: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
          nullable: false,
          default:0,
          name: "excess_quantity",
    })
    excessQuantity: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
          nullable: false,
          default:0,
          name: "damaged_quantity",
    })
    damagedQuantity: number;
    @Column({
        type: 'enum',
        enum: TransferStatusEnum,
        nullable: false,
        name: 'transfer_status',
        default:TransferStatusEnum.IN_TRANSIT,
    })
    transferStatus: TransferStatusEnum;
    @Column("int", {
        nullable: true,
        name: "from_plant_id",
    })
    fromPlantId: number;
    @Column("int", {
        nullable: true,
        name: "to_plant_id",
    })
    toPlantId: number;
    @Column("int",{
        nullable:false,
        name:"current_position",
        default: 0
        })
    currentPosition:number;
    @Column("varchar", {
        nullable: false,
        name: "current_position_code",
        length:50
    })
    currentPositionCode: string;
  
    @Column("int", {
        nullable: false,
        default:0,
        name: "job_cartons",
        })
        jobCartons: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        default:0,
        name: "issued_quantity",
        })
        issuedQuantity: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        default:0,
        name: "received_quantity",
        })
        receivedQuantity: number;
    @Column("int",{
        nullable:false,
        name:"target_position",
        default: 0
        })
    targetPosition:number;
    @Column("varchar", {
        nullable: false,
        name: "target_position_code",
        length:50
    })
    targetPositionCode: string
    @Column("int",{
        nullable:false,
        name:"real_position",
        default: 0
        })
    realPosition:number;
    @Column("varchar", {
        nullable: false,
        name: "real_position_code",
        length:50
    })
    realPositionCode: string
    @Column("varchar", {
        nullable: false,
        name: "unit_code",
        length:50
    })
    unitCode: string
    @Column("varchar", {
        nullable: false,
        name: "from_plant_code",
        length:50
    })
    fromPlantCode: string
    @Column("varchar", {
        nullable: false,
        name: "to_plant_code",
        length:50
    })
    toPlantCode: string
    @Column({
        type: 'enum',
        enum: StockTypeStatus,
        nullable: false,
        name: 'stock_type'
    })
    stockType: string;
    @Column("varchar", {
        name: "no_of_pouches",
        length:50,
    })
    noOfPouches: string;

    @Column("varchar", {
        name: "pouches_per_row",
        length:50,
    })
    pouchesPerRow: string;
    @Column("varchar", {
        name: "uom",
        length:50,
    })
    uom: string;
    @Column('varchar',{
        name: 'po_number',
        length: 50
    })
    poNumber: string;
    @Column("datetime", {
        nullable: true,
        name: "date"
    })
    date: Date;
    @Column("int", {
        nullable: false,
        name: "unit_id",
        })
        unitId: number;
        @Column("int", {
            nullable: false,
            name: "stock_id",
            })
            stockId: number;
    @Column("boolean",{
        nullable:false,
        default:false,
        name:"sync_status"
        })
    syncStatus?:boolean;
    
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default:"Admin",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

}
